<div class="circle-block">
  <div class="circle-block__circle" [ngStyle]="styleBlock">
    <p [ngStyle]="styleText">{{ content }}</p>
  </div>
</div>